import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import EventData from "../../data/event/EventData.json";
import * as deviceSyncAnimation from "../../assets/animations/Device sync animation.json";
import Lottie from "react-lottie";
import HomeFourAbout from "../../components/home-four/HomeFourAbout";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import Demo from "../../innerpages/Demo";

const HappyGastroOld = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { modal, openModal } = React.useState(false);
  const eventId = parseInt(id, 10);
  const data = EventData.filter((event) => event.id === eventId);
  const isHomePage = window.location.pathname === "/";

  const { pathname } = useLocation();
  const host = (window.location.hostname || "").replace(/^www\./i, "").toLowerCase();

  const normalizedPathname = pathname !== "/" ? pathname.replace(/\/+$/, "") : pathname;

  const showHeaderImage =
      host === "happygastro.hu" &&
      (normalizedPathname === "/" || normalizedPathname === "/gastro-ettermi-szoftver");

  return (
    <>
      <SEO title={t('happyGastro.seoTitle')} description={t('happyGastro.seoDescription')}/>
      <Layout>
          {showHeaderImage ? (
              <div className="col-lg-12">
                  <div className="inner">
                      <img src={"https://images.happysolutions.hu/Happy%20Gastro_kicsi.png"} alt="Happy Trade"/>
                  </div>
                  <div className="row g-5 align-items-center">
                      <div className="col-lg-12">
                          <div className="inner">
                              <div className="content text-start">
                                  <h1 className="title">{t('happyGastro.hero.title')}</h1>
                                  <p className="description" style={{ fontSize: 18}}>
                                      {t('happyGastro.hero.subtitle')}
                                  </p>
                                  <div className="btn-area" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                                      {/* <button className="edu-btn" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                                          {t('happyGastro.hero.ctaDemo')} <i className="icon-arrow-right-line-right"></i>
                                      </button> */}
																			<Demo title={t('erpPage.hero.ctaDemo')}/>
                                      <button className="edu-btn btn-secondary" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                                          {t('happyGastro.hero.ctaConsult')}
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          ) : (
              <div id="trade-hero" className="slider-area banner-style-3 bg-image" style={{ margin: "30px 0", padding: "2rem 0", backgroundColor: "linear-gradient(180deg, #f8fbff 0%, #ffffff 100%)", background: 'url(https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/happy-trade-hero.jpg)', backgroundSize: 'cover', backgroundPosition: 'center center', minHeight: 400}}>
                  <div className="d-flex align-items-center" style={{paddingBottom: 40}}>
                      <div className="container eduvibe-animated-shape">
                          <div className="row g-5 align-items-center">
                              <div className="col-lg-12">
                                  <div className="inner">
                                      <div className="content text-start" style={{color: 'white'}}>
                                          <h1 className="title" style={{color: 'white'}}>{t('happyGastro.hero.title')}</h1>
                                          <p className="description" style={{ fontSize: 18, color: 'white' }}>
                                              {t('happyGastro.hero.subtitle')}
                                          </p>
                                          <div className="btn-area" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                                              {/* <button className="edu-btn" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                                                  {t('happyGastro.hero.ctaDemo')} <i className="icon-arrow-right-line-right"></i>
                                              </button> */}
																							<Demo title={t('erpPage.hero.ctaDemo')}/>
                                              <button className="edu-btn btn-secondary" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                                                  {t('happyGastro.hero.ctaConsult')}
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-lg-5">
                                  <div className="banner-image">
                                      <div className="banner-main-image">
                                          {false && (
                                              <img
                                                  style={{borderRadius: 8}}
                                                  className="img-01"
                                                  src="/images/mini-cart.jpg"
                                                  alt="Happy Trade"
                                                  width="640"
                                                  height="480"
                                                  decoding="async"
                                                  fetchpriority="high"
                                          />
                                          )}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          )}

        <div className="happy-pos edu-event-details-area edu-event-details edu-section-gap bg-color-white" style={{overflowX: 'hidden'}}>
          <div className="container">
            <div className="row g-5">
                <div className="col-lg-12">
                    <div className="inner">
                    </div>
                </div>
              <div className="col-lg-7">
                <div className="content" style={{ marginTop: 0 }}>
                  <h4 className="title" style={{ fontSize: 30 }}>
                    {t('happyGastro.more1.title')}
                  </h4>
                  <ul>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more1.b1')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more1.b2')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more1.b3')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      <a
                        className={"text-primary"}
                        href={"/termekeink/happy-pos"}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        {t('happyGastro.more1.mobileOrder')}
                      </a>
                      {t('happyGastro.more1.mobileOrderTail')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more1.b5')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more1.ntakPre')}
                      <a
                        className={"text-primary"}
                        href={"https://ntak.hu/"}
                        target={"_blank"}
                        rel="noreferrer"
                      >
                        {t('happyGastro.more1.ntakLink')}
                      </a>{" "}
                      {t('happyGastro.more1.ntakPost')}
                    </li>
                  </ul>
                </div>

                <div className="content" style={{ marginTop: 0 }}>
                  <h4 className="title" style={{ fontSize: 30 }}>
                    {t('happyGastro.more2.title')}
                  </h4>
                  <ul>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more2.b1')}
                    </li>
                    <li style={{ fontSize: 17 }}>{t('happyGastro.more2.b2')}</li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more2.b3')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more2.b4')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more2.b5')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more2.b6')}
                    </li>
                    <li style={{ fontSize: 17 }}>
                      {t('happyGastro.more2.b7')}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="eduvibe-sidebar" style={{ marginTop: -100 }}>
                  <div className="eduvibe-widget eduvibe-widget-details mt--60">
                    <h5 className="title text-center">
                      {t('happyGastro.sidebar.syncTitle')}
                    </h5>
                    <div className="widget-content">
                      <Lottie
                        options={{
                          loop: false,
                          autoplay: true,
                          animationData: deviceSyncAnimation,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid cover",
                          },
                        }}
                        width={"300px"}
                        height={"300px"}
                      />
                      <p style={{ textAlign: "justify", marginBottom: -20 }}>
                        {t('happyGastro.sidebar.syncDesc')}
                      </p>
                    </div>
                  </div>

                  {false && <div className="event-widget event-widget-details mt--40">
                    <h5 className="title text-center">Bármely rendszeren*</h5>
                    <div className="widget-content">
                      <img
                          src={require("../../assets/images/operating-systems.jpg")}
                          alt="Éttermmi szoftverünk minden platformon megállja a helyét!"
                      />
                      {false && (
                          <div className="read-more-btn mt--15">
                            <Link className="edu-btn w-100 text-center" to="#">
                              Töltse le most!
                            </Link>
                          </div>
                      )}
                    </div>
                  </div>}
                  <div className="event-widget event-widget-details mt--40">
                    <h5 className="title text-center">{t('happyGastro.sidebar.osTitle')}</h5>
                    <div className="row justify-content-center align-items-center" style={{margin: '0 auto', flexWrap: 'nowrap'}}>
                      <div className="col widget-content">
                        <img style={{height: '6rem', aspectRatio: '1/1', objectFit: 'contain'}} src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/Windows_logo.svg.png" alt="Windows"/>
                        {false && <img src={require('../../assets/images/operating-systems.jpg')}
                                       alt="Éttermmi szoftverünk minden platformon megállja a helyét!"/>}
                        {false&&<div className="read-more-btn mt--15">
                          <Link className="edu-btn w-100 text-center" to="#">Töltse le
                            most!</Link>
                        </div>}
                      </div>
                      <div className="col widget-content">
                        <img style={{height: '6rem', aspectRatio: '1/1', objectFit: 'contain'}} src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/Apple_logo_black.svg.png" alt="Apple"/>
                      </div>
                      <div className="col widget-content">
                        <img style={{height: '6rem', aspectRatio: '1/1', objectFit: 'contain'}} src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/Android_robot.svg.webp" alt="Android"/>
                      </div>
                      <div className="col widget-content">
                        <img style={{height: '7rem', aspectRatio: '1/1', objectFit: 'contain'}} src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/linux.png" alt="Linux"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};
export default HappyGastroOld;
